import {Flex} from 'antd';
import siteService from "../../../../../../services/siteService";
import {LoadModelJson, Obstruction_Tree_Initial_Setup} from "../../../Three-JS-Viewer/Controllers/Loader";
import {useViewerStore} from "../../../../../../store/store";
import React, {useContext, useState} from "react";
import {HouseLineIcon, SparkleIcon, TreeStructureIcon} from "@phosphor-icons/react";
import {VscNewFolder} from "react-icons/vsc";
import {FiChevronUp} from "react-icons/fi";
import {IoIosLock, IoIosUnlock} from "react-icons/io";
import {BsShieldFillCheck, BsShieldFillExclamation, BsShieldLockFill} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
import {getSite} from "../../../../../../hooks/useLoadOriginalSite";
import {checkAndSetSetbackOverrideFlag} from "../../../Three-JS-Viewer/Controllers/PathwayControl";
import {setDeactivateRoofArrInStoreFromDesignData} from "../../../Three-JS-Viewer/Controllers/Common";
import {resetLayers} from "../../../../../../helpers/storeHelpers";
import {usePrimaryColor} from "../../../../../../contexts/ThemeColorContext";
import {ThemeContext} from "../../../../../../contexts/ThemeContext";
import { pickCustomerSiteRestrictions } from "../../../../../../helpers/customerSiteRestrictions";
import {isEnFinLossesVendor} from "../../../../../../Constants";
import { useCurrentUser } from '../../../../../../contexts/UserContext';
const DesignList : React.FC = () => {


    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const primaryColor = usePrimaryColor();
    const {theme} = useContext(ThemeContext);
    const navigate = useNavigate()
    const {hasCapability} = useCurrentUser();

    const {designList, 
            selectedDesignIndex,
        } = useViewerStore(state => state);
    const [toggle, setToggle] = useState(false);
    const stage = sessionStorage.getItem('currentStage');
    const toggleDesign = () => setToggle(!toggle);
    const onClickDesign = async (index : number) => {
        useViewerStore.setState({
            isSiteReCentered: false, 
            isDesignLoading: true, 
            selectedSiteDesign : null,
            roofsAltered: [],
            selectedDesignIndex: index,
        });
        sceneViewer.mapView = true;
        resetLayers(); // Reset layer visibility to default
        designList.map((design) => {
            if (design.Active_Ind === false) {
                //For New Design
                useViewerStore.setState({designID: 0});
                useViewerStore.setState({isInActiveDesign: true});
            }
        });
        const opId = sessionStorage.getItem('SalesForceId') || '';
        const designNo = designList[index].Design_No;
        const versionNo = designList[index].Version_No;
        const data = await siteService.retrieveSiteDesignDetailsWithDesignData(opId, designNo, versionNo);
        const designData = data.DesignDataList[0].Design_Data;

        const siteDetails = useViewerStore.getState().siteDesignDetails;
        const siteEnvelope =
            Array.isArray(siteDetails) && siteDetails.length > 0 ? siteDetails[0] : undefined;
        useViewerStore.setState({
            sitejson: JSON.stringify(designData),
            selectedLossesVendor: designList[index].MultipliersVendor,
            customerSiteRestrictions: pickCustomerSiteRestrictions(
                data,
                data.DesignDataList?.[0],
                designList[index],
                siteEnvelope,
            ),
        });

        setDeactivateRoofArrInStoreFromDesignData(designList,index, JSON.parse(designData).deactivatedRoofIdArr ?? []);
        checkAndSetSetbackOverrideFlag(designData)
        await LoadModelJson(sceneViewer, designData, 'glb');
        if (useViewerStore.getState().isTreeLabelVisible) {
            sceneViewer.toggleTreeLabel();
        }
        useViewerStore.setState({isDesignLoading: false});
    };

    const loadOriginalSite = async () => {
        useViewerStore.setState({isDesignLoading:true, deactivatedRoofIdArr: [], selectedDesignIndex: -1, customerSiteRestrictions: '', isAiGeneratedDesign: false});
        Obstruction_Tree_Initial_Setup(sceneViewer);
        sceneViewer.mapView = true;
        resetLayers();
        await getSite(navigate);
        useViewerStore.setState({isDesignLoading: false});
    };

    const getLocalTime = (isoString : string) => {
        const globalTime = new Date(isoString);
        const localTime = new Date(globalTime.getTime() - (globalTime.getTimezoneOffset() * 60000));
        return localTime?.toLocaleString();
    }

    const getHouseIconDefaultColor = (): string  => {
        return theme === 'dark' ? '#ffffff' : '#000000';
    };

    return (
        <Flex vertical>
            <Flex justify={'left'} align={'center'} gap={5} className={"sidebar-headings"}><TreeStructureIcon
                size={32}/>Design & Versioning</Flex>
            <br/>
            <div className={`user__design--toggle ${toggle ? 'active' : ''}`} onClick={toggleDesign}>
                <VscNewFolder size={24}/>
                <span className='user__label'>Designs</span>
                <FiChevronUp className='user__design--arrow' size={24}/>
            </div>
            <div className={`user__design--menu menu ${toggle ? 'open' : ''}`}>
                <ul className='menu__list'>
                    {
                        designList?.map((design, index) => {

                            return (
                                <li key={index}
                                    className={`menu__item ${selectedDesignIndex == index && 'active'}`}
                                    onClick={() => onClickDesign(index)}>
                                    <HouseLineIcon size={18} color={selectedDesignIndex == index ? primaryColor : getHouseIconDefaultColor()} />
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: "180px"
                                    }}>
                                        {design.IsAiGeneratedDesign && (
                                            <span
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 4,
                                                    fontSize: 11,
                                                    color: theme === 'dark' ? '#4ade80' : '#16a34a',
                                                    marginTop: 2,
                                                }}
                                            >
                                                <SparkleIcon size={14} weight="fill" />
                                                AI Design
                                            </span>
                                        )}
                                        <span
                                            className='menu__label'>Design : {design.Design_No} - Version : {design.Version_No}</span>
                                        <span>{design.User_Created_Id} - {design.User_Department}
                                            {design.Active_Ind ? "" : design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null ? " - Not Active" : ""}
                                        </span>
                                        <span>{getLocalTime(design.User_Created_Timestamp)}</span>
                                        <span>Size: {design.System_Size_kWdc ?? 0} kW DC</span>
                                        {
                                        hasCapability('Losses_Vendors') && (
                                            isEnFinLossesVendor(design.MultipliersVendor) && (
                                                <span>Losses: EnFin</span>
                                            )
                                        )}
                                        {Number(stage) >= 4 && Number(stage) <= 10 && design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null && (
                                            <div
                                                className={`certify ${selectedDesignIndex == index && 'active'}`}> {design.Design_Certification_Status}
                                                {design.Design_Certification_Status === "As-Built Certified"
                                                    ? <BsShieldLockFill size={14} style={{ marginLeft: "10px" }} color='#5aac5a' />
                                                    : design.Design_Certification_Status === "Certified Design Override"
                                                        ? <BsShieldFillExclamation size={14} style={{ marginLeft: "10px" }} color='#ca4a4a' />
                                                        : design.Design_Certification_Status === "Pre-Install Certified"
                                                            ? <BsShieldFillCheck size={14} style={{ marginLeft: "10px" }} color='#dadada' />
                                                            : <BsShieldFillCheck size={14} style={{ marginLeft: "10px" }} color='#ffb300' />}
                                            </div>
                                        )}

                                    </div>
                                    {design.Design_Certification_Status !== "Not Certified" && design.Design_Certification_Status !== null && (
                                        <div className={`lock-design ${selectedDesignIndex === index && 'active'}`}>
                                            {design.Design_Certification_Status === "Certified Design Override" ?
                                                <IoIosUnlock size={25}/> : <IoIosLock size={25}/>}
                                        </div>
                                    )}
                                </li>
                            )
                        })
                    }
                    <li className={`menu__item ${selectedDesignIndex == -1 && 'active'}`}
                        onClick={() => loadOriginalSite()}>
                        <HouseLineIcon color={selectedDesignIndex == -1 ?  primaryColor : getHouseIconDefaultColor()} />
                        <span className='menu__label'>Original Site</span>
                    </li>
                </ul>
            </div>
        </Flex>
    );
}

export default DesignList;